module.exports = __webpack_public_path__ + "static/media/colicoli05.ec99110d.webp";